module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/design-tile-images/design-tile-12-cfa0527df851226fad6f298c13088d93.webp";